import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { AutoCompleteGroup } from "../../Common/AutoCompleteGroup/AutoCompleteGroup";
import { BaseComponent } from "../../Common/BaseComponent/BaseComponent";
import { TextBox } from "../../Common/TextBox/TextBox";
import { Timeline } from "../../Events/Timeline/Timeline";
import { EventsOfDay } from "../EventsOfDay/EventsOfDay";
import { $$requestManager } from "../../Core/RequestManager";
import { AutoComplete } from "../../Common/AutoComplete/AutoComplete";

export class SearchForm extends BaseComponent
{
    private _autoGroupTopics: AutoCompleteGroup;
    private _autoSearch: AutoComplete;
    private _isFreeText: boolean;
    private _pnlAdvanced: HTMLElement;
    private _pnlEventsOfDay: HTMLElement;
    private _pnlSimple: HTMLElement;
    private _pnlTitle: HTMLElement;
    private _timeline: Timeline;
    private _title: string;
    private _txtStart: TextBox;
    private _txtEnd: TextBox;

    constructor(props)
    {
        super(props);
    }

    _onBtnSearchClick()
    {
        this._executeSearch();
    }

    _onTblKeyPress(evt)
    {
        if (evt.key === "Enter")
        {
            this._executeSearch();
        }
    }

    _executeSearch(topicId?: string, text?: string)
    {
        let startDate = $$.parseFlexDate(this._txtStart.getValue());
        let endDate = $$.parseFlexDate(this._txtEnd.getValue(), true);

        $$requestManager.execute("api/event/loadresults",
            {
                Text: topicId ? null : text,
                Topics: topicId ? [topicId] : this._autoGroupTopics.getIds(),
                Start: startDate,
                End: endDate,
                Grouping: 4
            }, this._onLoadResultsSuccess.bind(this));
    }

    _onLoadResultsSuccess(timeline)
    {
        if (this._isFreeText)
        {
            this._pnlTitle.innerHTML = `Events with keywords: <span style="font-weight: normal">${this._title}</span>`;
        }
        else
        {
            this._pnlTitle.innerText = "History of " + this._title;
        }
        $$.hide(this._pnlEventsOfDay);
        this._timeline.setTimeline(timeline);
    }

    private _onLnkAdvancedClick()
    {
        $$.hide(this._pnlSimple);
        $$.show(this._pnlAdvanced);
    }

    private _onAutoSearchChange()
    {
        let value = this._autoSearch.getValue();
        this._title = this._autoSearch.getText();
        this._isFreeText = !value && !!this._title;

        this._autoSearch.setValue(null);
        this._executeSearch(value, this._title);
    }

    public override componentDidMount()
    {
        super.componentDidMount();
    }

    render()
    {
        return (
            <div ref={(ref) => this._registerContainer(ref)} style={{ width: "100%" }} >
                <div class="timelineLeftPane">
                    <div>
                        <div onKeyPress={this._onTblKeyPress.bind(this)}>
                            <div ref={(ref) => this._pnlSimple = ref} className="formElement" style={{ textAlign: "center", marginBottom: "10px"}}>
                                <AutoComplete
                                    ref={(ref) => this._autoSearch = ref}
                                    AllowFreeText={true}
                                    LookupService="api/event/GetTopics"
                                    style={{ maxWidth: "350px", minWidth: "325px" }}
                                    onChange={this._onAutoSearchChange.bind(this)}
                                    Watermark="Search history by topic, person, or phrase"
                                />
                                <input type="button" onClick={this._onBtnSearchClick.bind(this)} style={{ background: "url('images/search.png') center center no-repeat rgb(110 139 198)",verticalAlign: "bottom", margin: "0 10px 0 0", height: "33px", padding:"0 18px" }} />
                                <a onClick={this._onLnkAdvancedClick.bind(this)} href="javascript:void(0)" style="display:none">Advanced</a>
                            </div>

                            <div ref={(ref) => this._pnlAdvanced = ref} style={{ display: "none" }}>

                                <div className="formElement">
                                    <AutoCompleteGroup Descriptor="Topics"
                                        ref={(ref) => this._autoGroupTopics = ref}
                                        LookupService="api/event/GetTopics" />
                                </div>

                                <div className="formElement">
                                    <TextBox Descriptor="Start Date" ref={(ref) => this._txtStart = ref} /> <em>to</em>&nbsp;
                                    <TextBox Descriptor="End Date" ref={(ref) => this._txtEnd = ref} />
                                </div>
                                <input type="button" value="Create Timeline" onClick={this._onBtnSearchClick.bind(this)} />
                            </div>

                        </div>
                        
                    </div>
                    <div style="margin-top: 50px;" ref={(ref) => this._pnlEventsOfDay = ref}>
                        <EventsOfDay onTopicSelected={(topicId) => this._executeSearch(topicId)} onEventSelected={(eventId) => this._timeline.loadEvent(eventId)} />
                    </div>

                    <h3 style={{ marginLeft: "10px", color: "#4e5c85", borderBottom: "1px solid #bbb", display: "inline-block" }} ref={(ref) => this._pnlTitle = ref}></h3>

                    <Timeline ref={(ref) => this._timeline = ref} />

                </div>
            </div>
        );
    }
}